import styled from '@emotion/styled';

import { BasicFlex } from '../../../utils/Common';

import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';

import { formatCurrency } from '../../../utils/util';

import { useTheme } from '@mui/material';

const BalanceInfo = styled(BasicFlex)`
  font-size: 1.4rem;
  width: max-content;
  color: ${props => props.theme.colors.mildText};
  font-weight: 500;
`

const Pill = styled(BasicFlex)`
  width: fit-content;
  padding: .2rem .6rem;
  border-radius: 10px;
  background-color: ${props => props.$bg};
  color: ${props => props.$color};
  font-size: 1rem;
  gap: .2rem;
`

const TotalInfo = styled.div`
  text-align: right;
  width: max-content;
`

const WigBalance = ({ wig = {} }) => {
  let bg, color, Icon, balText;

  let price = wig.total_price;
  let paid = wig.total_paid;
  let balance = wig.balance;

  const theme = useTheme();
  
  if (wig.status !== "sold") {
    return formatCurrency(price);
  }

  if (balance === 0) {
    bg = theme.palette.success.light;
    color = theme.palette.success.main;
    Icon = CheckRoundedIcon;
    balText = "Paid";
  } else {
    bg = theme.palette.error.light;
    color = theme.palette.error.main;
    Icon = PriorityHighRoundedIcon;
    balText = "Bal";
  }
  return (
    <BalanceInfo gap=".2rem" dir="column">
      <TotalInfo><span>{formatCurrency(price)}</span></TotalInfo>
      <Pill $bg={bg} $color={color}>  {formatCurrency(balance)} <span>Bal</span></Pill>
    </BalanceInfo>
  )
};

export default WigBalance